import { render, staticRenderFns } from "./custom_events.vue?vue&type=template&id=45dc665e&scoped=true"
import script from "./custom_events.vue?vue&type=script&lang=js"
export * from "./custom_events.vue?vue&type=script&lang=js"
import style0 from "./custom_events.vue?vue&type=style&index=0&id=45dc665e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc665e",
  null
  
)

export default component.exports